import React from 'react';
import { connect } from 'react-redux';
import { KuposInput, KuposRadio } from '../../../common';
import KuposHelmet from '../../../common/KuposHelmet';
import HeroSection from '../../common/HeroSection/HeroSection';
import getIcons from '../../functions/getIcons/getIcons';
import ThemeNineTitle from '../common/ThemeNineTitle';
import { useState } from 'react';

const ThemeSevenSpecialServicesScreen = props => {

  const [checked, setChecked] = useState(true)
  const operator = props.home && props.home.operator;
  return props.home.operator ? (
    <div className="themes-theme-nine-special-services-screen">
      <KuposHelmet />
      <div style={{ position: 'relative', marginTop: -20 }}>
        <HeroSection
          // height={'30vh'}
          heroImage={getIcons('specialServiceBanner')}
          title={'Servicios especiales '}
          description={'Home / Servicios especiales '}
        />
      </div>

      <ThemeNineTitle title={'¡Solicita tu viaje privado!'} />

      <div class="special-service-container">
        <div className='information'>
          <p>Si quieres cotizar un <span className='bold-text'>servicio exclusivo</span> de transporte para un <span className='bold-text'> viaje corporativo, </span> de entretención,
            para <span className='bold-text'>clubes</span> o <span className='bold-text'>equipos</span>, escríbenos y te contactaremos a la brevedad posible.</p>
        </div>

        <div className='spl-form-container '>

          <div className='form-row'>
            <div className="contact-input-item">
              <div className="contact-input-label less-bold-text ">Nombre Completo</div>
              <KuposInput
                type="text"
                placeholder="Ej. Pedro"
                inputOuterStyle={{ border: '1px solid #cccc' }}
                className={'input-theme-nine'}
              />
            </div>

            <div className="contact-input-item">
              <div className="contact-input-label less-bold-text ">Tipo de documento </div>
              <div className='d-flex'>
                <div className="kupos-payment-method kupos-payment-method-bank-deposit flex-row">
                  <label className='radio-and-label'>
                    <div className="kupos-radio">
                      <input
                        type="radio"
                        checked={checked}
                        onChange={() => { setChecked(!checked) }}
                      />
                      <span className={checked ? 'active' : ''}></span>
                      {checked ? (
                        <div className="icon-selection-circle-selected"></div>
                      ) : (<div className="icon-selection-circle-not-selected"></div>)}
                    </div>
                    <span>{"Chileno "}</span>
                  </label>

                  <label className='radio-and-label ml-40'>
                    <div className="kupos-radio">
                      <input
                        type="radio"
                        checked={!checked}
                        onChange={() => { setChecked(!checked) }}
                      />
                      <span className={!checked ? 'active' : ''}></span>
                      {!checked ? (
                        <div className="icon-selection-circle-selected"></div>
                      ) : (<div className="icon-selection-circle-not-selected"></div>)}
                    </div>
                    <span>{"Otro  "}</span>
                  </label>
                </div>

              
              </div>
            </div>
          </div>

          <div className='form-row'>
            <div className="contact-input-item">
              <div className="contact-input-label less-bold-text ">Teléfono</div>
              <KuposInput
                type="text"
                placeholder="+56 9 0000 0000"
                inputOuterStyle={{ border: '1px solid #cccc' }}
                className={'input-theme-nine'}
              />
            </div>

            <div className="contact-input-item">
              <div className="contact-input-label less-bold-text ">Email </div>
              <KuposInput
                type="email"
                placeholder="ejemplo@gmail.com"
                inputOuterStyle={{ border: '1px solid #cccc' }}
                className={'input-theme-nine'}
              />
            </div>

            <div className="contact-input-item">
              <div className="contact-input-label less-bold-text ">TNro. documento </div>
              <KuposInput
                type="text"
                placeholder="xx.xxx.xxx-x"
                inputOuterStyle={{ border: '1px solid #cccc' }}
                className={'input-theme-nine'}
              />
            </div>

            <div className="contact-input-item">
              <div className="contact-input-label less-bold-text ">Cantidad de pasajeros </div>
              <KuposInput
                type="text"
                placeholder="0"
                inputOuterStyle={{ border: '1px solid #cccc' }}
                className={'input-theme-nine'}
              />
            </div>
          </div>

          <div className='form-row'>
            <div className="contact-input-item">
              <div className="contact-input-label less-bold-text ">Origen</div>
              <KuposInput
                type="text"
                placeholder="Origen"
                inputOuterStyle={{ border: '1px solid #cccc' }}
                className={'input-theme-nine'}
                icon={getIcons('Origin')}
              />
            </div>

            <div className="contact-input-item">
              <div className="contact-input-label less-bold-text ">Destino </div>
              <KuposInput
                type="text"
                placeholder="Destino"
                inputOuterStyle={{ border: '1px solid #cccc' }}
                className={'input-theme-nine'}
                icon={getIcons('Destination')}
              />
            </div>
          </div>

          <div className='form-row'>
            <div className="contact-input-item">
              <div className="contact-input-label less-bold-text ">Descripción del viaje</div>
              <textarea
                placeholder="Opcional"
                inputOuterStyle={{ border: '1px solid #cccc' }}
                className={'input-theme-nine'}
              >
              </textarea>
            </div>
          </div>

          <div className="contact-input-item-btn center ">
            <button
              class="btn submit-btn  bold-text"
              style={{
                background:
                  operator &&
                  operator.color_codes &&
                  operator.color_codes.button_color &&
                  operator.color_codes.button_color,
                color: 'white',
                // width: '100%',
              }}
            >
              ENVIAR
            </button>
          </div>


        </div>
      </div>
    </div>
  ) : null;
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

export default connect(mapStateToProps, {})(ThemeSevenSpecialServicesScreen);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeNine/ThemeNinePages/ThemeNineSpecialServicesScreen.js